import { Row, Col } from 'src/componentes/grid';
import { useIntl } from 'react-intl';

import Input from 'src/componentes/input';
import TipoFluxoAprovacaoLookup from 'src/lookups/tipo-fluxoaprovacao';
import NumeroEtapasLookup from 'src/lookups/numeroEtapasLookup';
import ItemOrganizacaoLookup from 'src/lookups/item-organizacao';
import { capitalizeFirstLetter } from 'src/utils/string';
import useAuth from 'src/hooks/useAuth';

const Search = ({ model }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  return (
    <>
      <Row>
        <Col>
          <Input model={model.getModel('idIntegracao')} />
        </Col>
      </Row>
      <Row>
        <Col>
          <Input model={model.getModel('nome')} />
        </Col>
      </Row>
      <Row>
        <Col>
          <TipoFluxoAprovacaoLookup
            model={{
              label: intl.formatMessage({ id: 'tipo' }),
              value: model.getModel('tipoFluxoAprovacao').value,
              requestChange: model.getModel('tipoFluxoAprovacao').requestChange,
              errors: model.getModel('tipoFluxoAprovacao').errors,
            }}
            clearable={true}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <NumeroEtapasLookup
            model={{
              label: intl.formatMessage({ id: 'numeroEtapas' }),
              value: model.getModel('numeroEtapas').value,
              requestChange: model.getModel('numeroEtapas').requestChange,
              errors: model.getModel('numeroEtapas').errors,
            }}
            clearable={true}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <ItemOrganizacaoLookup
            model={{
              label: capitalizeFirstLetter(resources.area),
              value: model.getModel('organizacao').value,
              requestChange: model.getModel('organizacao').requestChange,
              errors: model.getModel('organizacao').errors,
            }}
            clearable={true}
          />
        </Col>
      </Row>
    </>
  );
};

export default Search;
